import React from 'react'
import type { SessionUser } from '../auth/mapLoginUser'

export interface UserContextValue {
    user: SessionUser | null
    setUser: React.Dispatch<React.SetStateAction<SessionUser | null>>
}

const UserContext = React.createContext<UserContextValue>({
    user: null,
    setUser: () => {},
})

export default UserContext
